import styled from 'styled-components';

export const Div = styled.div`
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;

  .events-only-switch {
    display: flex;
    align-items: center;
    gap: 10px;
    user-select: none;
    cursor: pointer;
  }
`;
